import { Control, Controller } from 'react-hook-form';
import { CatalogProductsFormData } from '../../create-product-dialog-types';
import { isEmptyString, isNotEmptyArray, isNotNullOrUndefined } from '@vy/utils';
import { createXeroIntegrationEntity } from '../../../../../../../utils/integration-entity-creators';
import { Autocomplete, TextField } from '@mui/material';
import { useFormattedXeroProducts } from '../../../../../../../hooks/use-formatted-xero-products';

type XeroProductsDropdownProps = {
  control: Control<CatalogProductsFormData>;
};

export const XeroProductsDropdownForCatalog: React.FC<XeroProductsDropdownProps> = ({
  control,
}) => {
  const { products: formattedProducts, setSearchInput } = useFormattedXeroProducts();

  return (
    <Controller
      control={control}
      name="xeroProduct"
      render={({ field }) => {
        const currentValue = isNotEmptyArray(field.value) ? field.value?.at(0) : null;

        const canFindProduct = isNotNullOrUndefined(currentValue) && isNotEmptyArray(formattedProducts);

        const matchingProduct = canFindProduct
          ? formattedProducts.find((product) => product.id === currentValue.integrationExternalId)
          : null;

        return (
          <Autocomplete
            options={formattedProducts}
            multiple={false}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={matchingProduct}
            onChange={(_, value) => {
              const newEntity = createXeroIntegrationEntity(value);
              field.onChange(newEntity ? [newEntity] : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Xero Products"
                placeholder="Select Xero product"
                size="small"
                slotProps={{
                  ...params.slotProps,

                  inputLabel: {
                    shrink: true,
                  }
                }}
                onChange={(e) => {
                  if (isEmptyString(e.target.value)) {
                    field.onChange(undefined);
                  } else {
                    setSearchInput(e.target.value);
                  }
                }}
              />
            )}
          />
        );
      }}
    />
  );
};
